import React, { useState } from 'react';
import {
  Card,
  Table,
  Button,
  Input,
  Select,
  Space,
  Tag,
  DatePicker,
  Row,
  Col,
  Statistic,
  Progress,
  message,
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  RiseOutlined,
  FallOutlined,
  EyeOutlined,
  LikeOutlined,
  MessageOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';

const { Option } = Select;

interface ContentPerformance {
  id: number;
  contentType: string;
  title: string;
  platform: string;
  publishTime: string;
  views: number;
  likes: number;
  comments: number;
  shares: number;
  engagementRate: number; // 互动率
  qualityScore: number; // 质量评分 0-100
  trend: 'up' | 'down' | 'stable';
  hasAd: boolean; // 是否含广告
  adImpressions?: number; // 广告展示次数
  adClicks?: number; // 广告点击次数
  adConversions?: number; // 广告转化次数
  adLink?: string; // 广告链接
  isComment?: boolean; // 是否为评论
  targetType?: 'live_room' | 'post' | 'video'; // 评论目标类型
  targetTitle?: string; // 目标标题
  commentLikes?: number; // 评论点赞数
  commentReplies?: number; // 评论回复数
  commentViews?: number; // 评论查看数
}

// Demo数据
const initialData: ContentPerformance[] = [
  {
    id: 1,
    contentType: 'bounce_edge_video',
    title: '抖奶擦边视频-001',
    platform: 'TikTok',
    publishTime: '2025-12-03 09:00:00',
    views: 125000,
    likes: 8500,
    comments: 1200,
    shares: 560,
    engagementRate: 8.2,
    qualityScore: 92,
    trend: 'up',
    hasAd: true,
    adImpressions: 125000,
    adClicks: 12500,
    adConversions: 1250,
    adLink: 'https://example.com/promotion?ref=001',
    isComment: false,
  },
  {
    id: 2,
    contentType: 'football_analysis_video',
    title: '今日足球对战分析-曼城vs利物浦',
    platform: 'YouTube',
    publishTime: '2025-12-03 08:00:00',
    views: 89000,
    likes: 6200,
    comments: 890,
    shares: 320,
    engagementRate: 8.3,
    qualityScore: 88,
    trend: 'up',
    hasAd: false,
    isComment: false,
  },
  {
    id: 3,
    contentType: 'beauty_live_preview',
    title: '美女直播预告图-小美',
    platform: 'Instagram',
    publishTime: '2025-12-03 10:00:00',
    views: 45000,
    likes: 3200,
    comments: 450,
    shares: 180,
    engagementRate: 8.5,
    qualityScore: 85,
    trend: 'stable',
    hasAd: true,
    adImpressions: 45000,
    adClicks: 4500,
    adConversions: 450,
    adLink: 'https://example.com/promotion?ref=003',
    isComment: false,
  },
  {
    id: 4,
    contentType: 'game_strategy_article',
    title: '游戏攻略-王者荣耀上分技巧',
    platform: 'Facebook',
    publishTime: '2025-12-02 10:00:00',
    views: 12000,
    likes: 800,
    comments: 120,
    shares: 45,
    engagementRate: 8.0,
    qualityScore: 75,
    trend: 'down',
    hasAd: false,
  },
  {
    id: 5,
    contentType: 'bounce_edge_video',
    title: '抖奶擦边视频-002',
    platform: 'TikTok Shop',
    publishTime: '2025-12-03 14:00:00',
    views: 98000,
    likes: 7200,
    comments: 980,
    shares: 420,
    engagementRate: 8.8,
    qualityScore: 90,
    trend: 'up',
    hasAd: true,
    adImpressions: 98000,
    adClicks: 9800,
    adConversions: 980,
    adLink: 'https://example.com/promotion?ref=005',
    isComment: false,
  },
  {
    id: 6,
    contentType: 'lottery_activity_video',
    title: '抽奖活动视频-001',
    platform: 'TikTok',
    publishTime: '2025-12-02 18:00:00',
    views: 35000,
    likes: 2100,
    comments: 320,
    shares: 150,
    engagementRate: 7.3,
    qualityScore: 70,
    trend: 'down',
    hasAd: true,
    adImpressions: 35000,
    adClicks: 3500,
    adConversions: 350,
    adLink: 'https://example.com/promotion?ref=006',
    isComment: false,
  },
  {
    id: 7,
    contentType: 'football_analysis_video',
    title: '今日足球对战分析-皇马vs巴萨',
    platform: 'YouTube',
    publishTime: '2025-12-03 12:00:00',
    views: 67000,
    likes: 4800,
    comments: 650,
    shares: 280,
    engagementRate: 8.6,
    qualityScore: 87,
    trend: 'up',
    hasAd: false,
    isComment: false,
  },
  {
    id: 8,
    contentType: 'comment',
    title: '评论-热门视频互动',
    platform: 'TikTok',
    publishTime: '2025-12-03 15:00:00',
    views: 0,
    likes: 0,
    comments: 0,
    shares: 0,
    engagementRate: 0,
    qualityScore: 85,
    trend: 'up',
    hasAd: false,
    isComment: true,
    targetType: 'video',
    targetTitle: '热门舞蹈视频',
    commentLikes: 320,
    commentReplies: 45,
    commentViews: 8500,
  },
  {
    id: 9,
    contentType: 'comment',
    title: '评论-直播间互动',
    platform: 'Bigo Live',
    publishTime: '2025-12-03 16:00:00',
    views: 0,
    likes: 0,
    comments: 0,
    shares: 0,
    engagementRate: 0,
    qualityScore: 88,
    trend: 'up',
    hasAd: true,
    adImpressions: 5000,
    adClicks: 500,
    adConversions: 50,
    adLink: 'https://example.com/promotion?ref=009',
    isComment: true,
    targetType: 'live_room',
    targetTitle: '美女主播直播间',
    commentLikes: 280,
    commentReplies: 35,
    commentViews: 6200,
  },
  {
    id: 10,
    contentType: 'comment',
    title: '评论-热门帖子互动',
    platform: 'Facebook',
    publishTime: '2025-12-03 17:00:00',
    views: 0,
    likes: 0,
    comments: 0,
    shares: 0,
    engagementRate: 0,
    qualityScore: 82,
    trend: 'stable',
    hasAd: false,
    isComment: true,
    targetType: 'post',
    targetTitle: '限时优惠活动',
    commentLikes: 150,
    commentReplies: 20,
    commentViews: 3500,
  },
  {
    id: 11,
    contentType: 'beauty_live_preview',
    title: '美女直播预告图-小丽',
    platform: 'Zalo',
    publishTime: '2025-12-03 11:00:00',
    views: 28000,
    likes: 1900,
    comments: 280,
    shares: 120,
    engagementRate: 8.2,
    qualityScore: 80,
    trend: 'stable',
    hasAd: false,
  },
];

const OperationDataDashboard: React.FC = () => {
  const [data, setData] = useState<ContentPerformance[]>(initialData);
  const [searchText, setSearchText] = useState('');
  const [selectedPlatform, setSelectedPlatform] = useState<string>('all');
  const [selectedContentType, setSelectedContentType] = useState<string>('all');

  // 统计数据
  const totalViews = data.reduce((sum, item) => sum + item.views, 0);
  const totalLikes = data.reduce((sum, item) => sum + item.likes, 0);
  const totalComments = data.reduce((sum, item) => sum + item.comments, 0);
  const totalShares = data.reduce((sum, item) => sum + item.shares, 0);
  const avgEngagementRate = data.length > 0
    ? (data.reduce((sum, item) => sum + item.engagementRate, 0) / data.length).toFixed(2)
    : 0;
  const avgQualityScore = data.length > 0
    ? (data.reduce((sum, item) => sum + item.qualityScore, 0) / data.length).toFixed(1)
    : 0;

  // 按内容类型统计
  const contentTypeStats = data.reduce((acc, item) => {
    if (!acc[item.contentType]) {
      acc[item.contentType] = {
        contentType: item.contentType,
        count: 0,
        totalViews: 0,
        totalLikes: 0,
        avgEngagementRate: 0,
        avgQualityScore: 0,
      };
    }
    acc[item.contentType].count++;
    acc[item.contentType].totalViews += item.views;
    acc[item.contentType].totalLikes += item.likes;
    acc[item.contentType].avgEngagementRate += item.engagementRate;
    acc[item.contentType].avgQualityScore += item.qualityScore;
    return acc;
  }, {} as Record<string, any>);

  Object.keys(contentTypeStats).forEach(key => {
    const stat = contentTypeStats[key];
    stat.avgEngagementRate = (stat.avgEngagementRate / stat.count).toFixed(2);
    stat.avgQualityScore = (stat.avgQualityScore / stat.count).toFixed(1);
  });

  const contentTypeList = Object.values(contentTypeStats).sort((a: any, b: any) => b.totalViews - a.totalViews);

  const filteredData = data.filter(item => {
    const matchSearch = item.title.includes(searchText) || item.contentType.includes(searchText);
    const matchPlatform = selectedPlatform === 'all' || item.platform === selectedPlatform;
    const matchContentType = selectedContentType === 'all' || item.contentType === selectedContentType;
    return matchSearch && matchPlatform && matchContentType;
  });

  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <RiseOutlined style={{ color: '#52c41a' }} />;
    if (trend === 'down') return <FallOutlined style={{ color: '#ff4d4f' }} />;
    return null;
  };

  const getQualityColor = (score: number) => {
    if (score >= 90) return '#52c41a';
    if (score >= 80) return '#1890ff';
    if (score >= 70) return '#faad14';
    return '#ff4d4f';
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: '内容类型',
      dataIndex: 'contentType',
      key: 'contentType',
      width: 180,
    },
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
      width: 250,
      ellipsis: true,
    },
    {
      title: '平台',
      dataIndex: 'platform',
      key: 'platform',
      width: 100,
    },
    {
      title: '发布时间',
      dataIndex: 'publishTime',
      key: 'publishTime',
      width: 180,
    },
    {
      title: '浏览量',
      dataIndex: 'views',
      key: 'views',
      width: 120,
      sorter: (a: ContentPerformance, b: ContentPerformance) => a.views - b.views,
      render: (views: number) => views.toLocaleString(),
    },
    {
      title: '点赞数',
      dataIndex: 'likes',
      key: 'likes',
      width: 100,
      sorter: (a: ContentPerformance, b: ContentPerformance) => a.likes - b.likes,
      render: (likes: number) => likes.toLocaleString(),
    },
    {
      title: '评论数',
      dataIndex: 'comments',
      key: 'comments',
      width: 100,
      sorter: (a: ContentPerformance, b: ContentPerformance) => a.comments - b.comments,
      render: (comments: number) => comments.toLocaleString(),
    },
    {
      title: '分享数',
      dataIndex: 'shares',
      key: 'shares',
      width: 100,
      sorter: (a: ContentPerformance, b: ContentPerformance) => a.shares - b.shares,
      render: (shares: number) => shares.toLocaleString(),
    },
    {
      title: '互动率',
      dataIndex: 'engagementRate',
      key: 'engagementRate',
      width: 120,
      sorter: (a: ContentPerformance, b: ContentPerformance) => a.engagementRate - b.engagementRate,
      render: (rate: number, record: ContentPerformance) => (
        <Space>
          <span>{rate}%</span>
          {getTrendIcon(record.trend)}
        </Space>
      ),
    },
    {
      title: '质量评分',
      dataIndex: 'qualityScore',
      key: 'qualityScore',
      width: 120,
      sorter: (a: ContentPerformance, b: ContentPerformance) => a.qualityScore - b.qualityScore,
      render: (score: number) => (
        <Progress
          percent={score}
          size="small"
          strokeColor={getQualityColor(score)}
          format={() => `${score}分`}
        />
      ),
    },
    {
      title: '是否含广告',
      dataIndex: 'hasAd',
      key: 'hasAd',
      width: 100,
      render: (hasAd: boolean) => (
        <Tag color={hasAd ? 'orange' : 'default'}>
          {hasAd ? '含广告' : '不含广告'}
        </Tag>
      ),
    },
    {
      title: '广告展示',
      dataIndex: 'adImpressions',
      key: 'adImpressions',
      width: 100,
      render: (impressions: number, record: ContentPerformance) => 
        record.hasAd ? (impressions?.toLocaleString() || 0) : '-',
    },
    {
      title: '广告点击',
      dataIndex: 'adClicks',
      key: 'adClicks',
      width: 100,
      render: (clicks: number, record: ContentPerformance) => 
        record.hasAd ? (clicks?.toLocaleString() || 0) : '-',
    },
    {
      title: '广告转化',
      dataIndex: 'adConversions',
      key: 'adConversions',
      width: 100,
      render: (conversions: number, record: ContentPerformance) => 
        record.hasAd ? (conversions?.toLocaleString() || 0) : '-',
    },
    {
      title: '广告链接',
      dataIndex: 'adLink',
      key: 'adLink',
      width: 200,
      ellipsis: true,
      render: (link: string, record: ContentPerformance) => 
        record.hasAd && link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {link}
          </a>
        ) : '-',
    },
    {
      title: '内容类型',
      dataIndex: 'isComment',
      key: 'isComment',
      width: 100,
      render: (isComment: boolean) => (
        <Tag color={isComment ? 'purple' : 'blue'}>
          {isComment ? '评论' : '发布'}
        </Tag>
      ),
    },
    {
      title: '评论目标',
      key: 'targetInfo',
      width: 200,
      render: (_: any, record: ContentPerformance) => {
        if (!record.isComment) return '-';
        const targetTypeMap: Record<string, string> = {
          live_room: '直播间',
          post: '帖子',
          video: '视频',
        };
        return (
          <div>
            <div>{targetTypeMap[record.targetType || ''] || record.targetType}</div>
            {record.targetTitle && (
              <div style={{ fontSize: 12, color: '#999' }}>{record.targetTitle}</div>
            )}
          </div>
        );
      },
    },
    {
      title: '评论点赞',
      dataIndex: 'commentLikes',
      key: 'commentLikes',
      width: 100,
      render: (likes: number, record: ContentPerformance) => 
        record.isComment ? (likes?.toLocaleString() || 0) : '-',
    },
    {
      title: '评论回复',
      dataIndex: 'commentReplies',
      key: 'commentReplies',
      width: 100,
      render: (replies: number, record: ContentPerformance) => 
        record.isComment ? (replies?.toLocaleString() || 0) : '-',
    },
    {
      title: '评论查看',
      dataIndex: 'commentViews',
      key: 'commentViews',
      width: 100,
      render: (views: number, record: ContentPerformance) => 
        record.isComment ? (views?.toLocaleString() || 0) : '-',
    },
  ];

  const platforms = Array.from(new Set(data.map(item => item.platform)));
  const contentTypes = Array.from(new Set(data.map(item => item.contentType)));

  return (
    <div style={{ padding: 24 }}>
      <div className="page-header">
        <h1>运营数据展示</h1>
        <p>展示内容效果数据，分析哪种数据产生好效果，哪种数据不好，用于优化内容生成策略</p>
      </div>

      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总浏览量"
              value={totalViews}
              prefix={<EyeOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="总点赞数"
              value={totalLikes}
              prefix={<LikeOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="平均互动率"
              value={avgEngagementRate}
              suffix="%"
              prefix={<MessageOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="平均质量评分"
              value={avgQualityScore}
              suffix="分"
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 内容类型效果分析 */}
      <Card title="内容类型效果分析" style={{ marginBottom: 24 }}>
        <Table
          rowKey="contentType"
          dataSource={contentTypeList}
          pagination={false}
          columns={[
            {
              title: '内容类型',
              dataIndex: 'contentType',
              key: 'contentType',
              width: 200,
            },
            {
              title: '发布数量',
              dataIndex: 'count',
              key: 'count',
              width: 100,
            },
            {
              title: '总浏览量',
              dataIndex: 'totalViews',
              key: 'totalViews',
              width: 120,
              sorter: (a: any, b: any) => a.totalViews - b.totalViews,
              render: (views: number) => views.toLocaleString(),
            },
            {
              title: '总点赞数',
              dataIndex: 'totalLikes',
              key: 'totalLikes',
              width: 120,
              sorter: (a: any, b: any) => a.totalLikes - b.totalLikes,
              render: (likes: number) => likes.toLocaleString(),
            },
            {
              title: '平均互动率',
              dataIndex: 'avgEngagementRate',
              key: 'avgEngagementRate',
              width: 120,
              render: (rate: string) => `${rate}%`,
            },
            {
              title: '平均质量评分',
              dataIndex: 'avgQualityScore',
              key: 'avgQualityScore',
              width: 120,
              render: (score: string) => (
                <Progress
                  percent={Number(score)}
                  size="small"
                  strokeColor={getQualityColor(Number(score))}
                  format={() => `${score}分`}
                />
              ),
            },
          ]}
        />
      </Card>

      {/* 内容详情列表 */}
      <Card>
        <Space style={{ marginBottom: 16 }}>
          <Input
            placeholder="搜索标题或内容类型"
            prefix={<SearchOutlined />}
            style={{ width: 300 }}
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
          />
          <Select
            style={{ width: 150 }}
            value={selectedPlatform}
            onChange={setSelectedPlatform}
            placeholder="选择平台"
          >
            <Option value="all">全部平台</Option>
            {platforms.map(platform => (
              <Option key={platform} value={platform}>{platform}</Option>
            ))}
          </Select>
          <Select
            style={{ width: 200 }}
            value={selectedContentType}
            onChange={setSelectedContentType}
            placeholder="选择内容类型"
          >
            <Option value="all">全部类型</Option>
            {contentTypes.map(type => (
              <Option key={type} value={type}>{type}</Option>
            ))}
          </Select>
          <Button icon={<ReloadOutlined />} onClick={() => message.info('刷新成功')}>
            刷新
          </Button>
        </Space>

        <Table
          rowKey="id"
          dataSource={filteredData}
          columns={columns}
          pagination={{ pageSize: 10 }}
          scroll={{ x: 1500 }}
        />
      </Card>
    </div>
  );
};

export default OperationDataDashboard;

